import { render, staticRenderFns } from "./DocumentCreate.vue?vue&type=template&id=57db7dcf&"
import script from "./DocumentCreate.vue?vue&type=script&lang=js&"
export * from "./DocumentCreate.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/documents.css?vue&type=style&index=0&lang=css&"
import style1 from "@/assets/styles/datepickers.css?vue&type=style&index=1&lang=css&"
import style2 from "@/assets/styles/modals.css?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports